import { createContext, useContext } from 'react';
import { PropertyFilters } from '@model';

export type PropertyFiltersModel = {
  filters: PropertyFilters;
  hidePropertyFiltersModal: () => void;
  isPropertyFiltersModalOpen: boolean;
  setFilters: (propertyFilters: PropertyFilters) => void;
  showPropertyFiltersModal: () => void;
};

export const PropertyFiltersContext = createContext<PropertyFiltersModel>({
  filters: new PropertyFilters(),
  isPropertyFiltersModalOpen: false,
  hidePropertyFiltersModal: () => {},
  setFilters: () => {},
  showPropertyFiltersModal: () => {},
});

export const usePropertyFilters = () => useContext(PropertyFiltersContext);
